import React, { Component } from 'react';
import PropTypes from 'prop-types';

const CustomerContactInfoHOC = (C) => {
  class CustomerContactInfoCont extends Component {
    static show() {
      return true;
    }

    static validate(props) {
      return Promise.all([
        props.validatorFactory().then(factory => factory.getCustomerInfoValidator(props.order))
          .then(validator => validator()),
        props.validatorFactory().then(factory => factory.getVerifyEmailValidator(props.order))
          .then(validator => validator()),
      ]);
    }

    render() {
      return (
        <C
          appearance={this.props.appearance}
          errors={this.props.errors.customerInfo}
          interactCustomerInfo={this.props.actions.interactCustomerInfo}
          order={this.props.order}
          updateCustomerInfo={this.props.actions.updateCustomerInfo}
          validate={data => this.props.validatorFactory().then(factory => [factory.getCustomerInfoValidator(this.props.order), data])}
          verifyEmailValidate={data => this.props.validatorFactory().then(factory => [factory.getVerifyEmailValidator(this.props.order), data])}
        />
      );
    }
  }

  CustomerContactInfoCont.PropTypes = {
    appearance:PropTypes.object.isRequired,
    order:PropTypes.object.isRequired,
    errors:PropTypes.shape({
      customerInfo:PropTypes.object.isRequired,
    }).isRequired,
    actions:PropTypes.shape({
      updateCustomerInfo:PropTypes.func.isRequired,
      interactCustomerInfo:PropTypes.func,
    }).isRequired,
    validatorFactory:PropTypes.func.isRequired,
  };

  return CustomerContactInfoCont;
};

export default CustomerContactInfoHOC;
